import React from 'react';
import styles from '../styles/StreakIcons.module.css';

const StreakIcons = ({ 
  count = 0, 
  maxCount = 7, 
  showLabels = false, 
  animate = false,
  weekData = null,
  className = '',
  theme = 'light'
}) => {
  // Debug logging
  if (animate && weekData) {
    console.log('StreakIcons animation debug:', {
      animate,
      weekData: weekData.map(day => ({
        dayName: day.dayName,
        isToday: day.isToday,
        isCompleted: day.isCompleted,
        isPast: day.isPast
      }))
    });
  }

  const renderIcons = () => {
    const icons = [];
    
    for (let i = 0; i < maxCount; i++) {
      const isFilled = i < count;
      const isCurrentDay = i === count - 1 && animate;
      
      icons.push(
        <div 
          key={i} 
          className={`${styles.streakIcon} ${isFilled ? styles.filled : styles.empty} ${isCurrentDay ? styles.animate : ''}`}
        >
          🔥
        </div>
      );
    }
    
    return icons;
  };

  const renderWeekDisplay = () => {
    const days = ['D', 'L', 'M', 'M', 'G', 'V', 'S'];
    const icons = [];
    
    // If weekData is provided, use actual completion data
    if (weekData) {
      return weekData.map((day, i) => {
        // Animate the current day if it's completed and we're in animation mode
        const isCurrentDay = day.isToday && day.isCompleted && animate;
        
        return (
          <div key={i} className={styles.weekItem}>
            <div 
              className={`${styles.streakIcon} ${
                day.isCompleted ? styles.filled : 
                day.isPast ? styles.missed : 
                styles.future
              } ${isCurrentDay ? styles.animate : ''}`}
              title={day.dayName}
            >
              🔥
            </div>
            {showLabels && (
              <div className={`${styles.dayLabel} ${day.isToday ? styles.todayLabel : ''}`}>
                {days[i]}
              </div>
            )}
          </div>
        );
      });
    }
    
    // Otherwise use count-based logic
    for (let i = 0; i < maxCount; i++) {
      const isFilled = i < count;
      const isCurrentDay = i === count - 1 && animate;
      
      icons.push(
        <div key={i} className={styles.weekItem}>
          <div 
            className={`${styles.streakIcon} ${isFilled ? styles.filled : styles.empty} ${isCurrentDay ? styles.animate : ''}`}
          >
            🔥
          </div>
          {showLabels && (
            <div className={`${styles.dayLabel} ${isCurrentDay ? styles.todayLabel : ''}`}>
              {days[i]}
            </div>
          )}
        </div>
      );
    }
    
    return icons;
  };

  const themeClass = theme === 'dark' ? styles.darkTheme : '';

  return (
    <div className={`${styles.streakIconsContainer} ${themeClass} ${className}`}>
      {showLabels ? renderWeekDisplay() : renderIcons()}
    </div>
  );
};

export default StreakIcons; 